import React from "react";
import { useMsal } from "@azure/msal-react";
import Button from "react-bootstrap/Button";

export const SignOutButton: React.FC = () => {
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect({ postLogoutRedirectUri: "/" }).catch((e: Error) => {
      console.error("Logout failed:", e);
    });
  };

  return (
    <Button variant="secondary" onClick={handleLogout}>
      Sign Out
    </Button>
  );
};
